import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';

import { DialogTitle, DialogActions, DialogContent } from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import validate from 'validate.js';
import isEmpty from 'lodash/isEmpty';
import * as userActions from '../user.actions';
import * as authActions from '../../auth/auth.actions';
import { Typography, withStyles } from 'material-ui';

const constraints = {
  password: {
    presence: true,
  },
  passwordConfirm: {
    presence: true,
    equality: {
      attribute: 'password',
      message: `Salasanat eivät täsmää`,
    },
  },
};

const styles = theme => ({
  input: {
    width: '100%',
  },
});

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        password: '',
        passwordConfirm: '',
      },
      errors: {},
      touchedFields: [],
      isValid: false,
    };
  }
  componentWillMount = () => {
    const { emailToken, validateEmailToken } = this.props;

    validateEmailToken(emailToken)
      .then(response => {
        this.setState({
          validatedToken: true,
          isValidToken: true,
          authToken: response.response.authToken,
        });
      })
      .catch(error => {
        this.setState({
          validatedToken: true,
          isValidToken: false,
          authToken: null,
        });
      });
  };
  handleChange = () => {
    const { resetPassword, emailToken, loginUserTokenAsync, history } = this.props;
    const { authToken, data } = this.state;
    resetPassword({
      emailToken,
      ...data,
    })
      .then(() => {
        loginUserTokenAsync(authToken).then(() => {
          history.replace('/');
        });
      })
      .catch(e => {
        history.replace('/');
      });
  };

  handleCancel = () => {
    this.props.history.push('/');
  };

  validate = () => {
    const { data } = this.state;
    const errors =
      validate(data, constraints, {
        format: 'custom',
      }) || {};
    const isValid = isEmpty(errors);
    this.setState({
      errors,
      isValid,
    });
  };
  onInputChange = event => {
    const { name } = event.target;
    if (name === '') return;
    this.updateData(event);
  };
  onBlur = event => {
    this.updateTouchedfields(event);
    this.validate();
  };

  updateTouchedfields(event) {
    const { name } = event.target;
    if (name === '') return;
    const touchedFields = [...this.state.touchedFields.filter(item => item !== name), name];
    this.setState({
      touchedFields,
    });
  }

  updateData(event) {
    const target = event.target;
    const { value, name } = target;
    if (name === '') return;

    this.setState(
      {
        data: {
          ...this.state.data,
          [name]: value,
        },
      },
      () => {
        this.validate();
      }
    );
  }
  render() {
    const { classes, ...other } = this.props;
    const { isValid, isValidToken, errors, touchedFields } = this.state;
    return isValidToken ? (
      <Paper onRequestClose={this.handleRequestClose} {...other}>
        <DialogTitle>Vaihda salasana</DialogTitle>
        <DialogContent>
          <TextField
            name="password"
            label="Salasana"
            type="password"
            autoComplete="off"
            margin="normal"
            className={classes.input}
            onBlur={this.onBlur}
            onChange={this.onInputChange}
            value={this.state.password}
          />
          <TextField
            name="passwordConfirm"
            label="Vahvista uusi salasana"
            type="password"
            autoComplete="off"
            margin="normal"
            className={classes.input}
            onBlur={this.onBlur}
            error={errors['passwordConfirm'] && touchedFields.indexOf('passwordConfirm') > -1}
            onChange={this.onInputChange}
            value={this.state.passwordConfirm}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Peruuta
          </Button>
          <Button disabled={!isValid} onClick={this.handleChange} color="primary">
            Vaihda salasana
          </Button>
        </DialogActions>
      </Paper>
    ) : (
      <Paper>
        <DialogTitle>Virheellinen linkki</DialogTitle>
        <DialogContent>
          <Typography>Tarkista saamasi linkki. Voit rekisteröityä kerran yhdellä sähköpostiosoitteella.</Typography>
          <DialogActions>
            <Button onClick={this.handleCancel} color="primary">
              Etusivulle
            </Button>
          </DialogActions>
        </DialogContent>
      </Paper>
    );
  }
}

const mapStateToProps = (state, { match }) => {
  const { emailToken } = match.params;

  return {
    emailToken,
  };
};

export default withRouter(
  connect(mapStateToProps, Object.assign({}, userActions, authActions))(withStyles(styles)(ResetPasswordPage))
);



// WEBPACK FOOTER //
// ./src/modules/user/components/ResetPasswordPage.js